export default "__VITE_ASSET__UfrfXUOq__"